'use client'

import { ButtonIconPrimary } from '@fukku/button/Icon/Primary'
import { ButtonPrimaryWithIcon } from '@fukku/button/PrimaryWithIcon'
import fukkuStyles from '@fukku/styles/classes.module.scss'
import type { FavoriteButtonProps } from 'favorite/types/types'
import { IconFavoffL } from 'icons/components/IconFavoffL'
import { IconFavoffS } from 'icons/components/IconFavoffS'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'
import { useFavorite } from '../hooks/useFavorite'
import styles from './FavoriteButtonPrimary.module.scss'

/**
 * Favorite primary button used mainly in PDP.
 * Label is shown only if the showLabel parameter is true.
 */
export const FavoriteButtonPrimary = ({
	productId,
	className = '',
	onClickCallback,
	dataTestIds,
	notification = false,
	selectedColorId,
	location,
	showLabel = false,
}: FavoriteButtonProps) => {
	const { t } = useLabels()
	const { isFavorite, handleClick, buttonLabel, showButton } = useFavorite({
		selectedColorId,
		productId,
		notification,
		onClickCallback,
		location,
		isSavedForLater: false,
	})

	if (!showButton) {
		return null
	}

	const icon = isFavorite ? <IconFavoffS /> : <IconFavoffL />
	const dataTestId = isFavorite ? dataTestIds.active : dataTestIds.inactive

	if (!showLabel) {
		return (
			<ButtonIconPrimary
				className={className}
				onClick={handleClick}
				data-testid={dataTestId}
			>
				{icon}
				<span className={fukkuStyles.srOnly}>{buttonLabel}</span>
			</ButtonIconPrimary>
		)
	}

	return (
		<ButtonPrimaryWithIcon
			className={cx(className, styles.primary)}
			onClick={handleClick}
			data-testid={dataTestId}
			icon={icon}
		>
			{t('pdp.addToWishlist.button')}
		</ButtonPrimaryWithIcon>
	)
}
